import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Link from 'flarum/common/components/Link';
import UserBadge from '../../../common/components/UserBadge';
export default class TableView extends Component {
  view() {
    if (!this.attrs.badges) {
      return null;
    }
    const badges = this.attrs.badges;
    return m("table", {
      width: '100%',
      className: 'BadgeTable'
    }, m("thead", null, m("tr", null, m("th", {
      scope: "col"
    }, app.translator.trans('v17development-flarum-badges.forum.badge.badges')), m("th", {
      scope: "col"
    }, app.translator.trans('v17development-flarum-badges.forum.badge.description')))), m("tbody", null, badges.map(badge => {
      return m("tr", null, m("td", null, m(Link, {
        href: app.route('badges.item', {
          id: badge.id()
        })
      }, m(UserBadge, {
        badge: badge,
        tooltip: false
      }))), m("td", null, badge.description(), m("div", {
        className: 'BadgeTableRewarded'
      }, app.translator.trans('v17development-flarum-badges.forum.badge.earned_count', {
        count: badge.earnedAmount(),
        b: m("b", null)
      }))));
    })));
  }
}
flarum.reg.add('v17development-user-badges', 'forum/components/BadgeCategoryList/TableView', TableView);